export const DEFAULT_BACK_COUNT = 0;

/**
 * Returns the formState of appropriate history according to backCount
 * @param {Array<object>} history - array of history items that contain formState
 * @param {number=} backCount - the back count number in history
 * @returns {(object|undefined)} formState
 */
export const getRequestFormState = (
  history,
  backCount = DEFAULT_BACK_COUNT
) => {
  const lastRequestHistoryItem = history
    .slice(backCount)
    .find(
      screen => screen.url === history[backCount]?.url && screen.isInitialScreen
    );

  return lastRequestHistoryItem?.formState;
};

/**
 * Returns the formState of appropriate history according to backCount
 * @param {Array<object>} history - array of history items that contain formState
 * @param {String} url - url you are looking for
 * @param {number=} backCount - the back count number in history
 * @returns {(object|undefined)} formState
 */
export const getRequestFormStateByUrl = (
  history,
  url,
  backCount = DEFAULT_BACK_COUNT
) => {
  const lastRequestHistoryItem = history
    .slice(backCount)
    .find(screen => screen.url === url && screen.isInitialScreen);

  return lastRequestHistoryItem?.formState;
};
